import {
  InfoCircleFilled,
  CheckCircleFilled,
  WarningFilled,
  CloseCircleFilled
} from '@ant-design/icons';

// Full-width banner with strong contrast — used at the top of pages /
// shells to announce subscription state, downtime, or CTAs. Tones map
// roughly to AntD's status palette but with our own tailwind classes so
// they're consistent with StatCard etc.

const TONE_STYLES = {
  info: {
    container: 'bg-brand-50 border-brand-200 text-brand-700',
    icon: <InfoCircleFilled className="text-brand-500" />
  },
  success: {
    container: 'bg-emerald-50 border-emerald-200 text-emerald-700',
    icon: <CheckCircleFilled className="text-emerald-500" />
  },
  warning: {
    container: 'bg-amber-50 border-amber-200 text-amber-700',
    icon: <WarningFilled className="text-amber-500" />
  },
  danger: {
    container: 'bg-rose-50 border-rose-200 text-rose-700',
    icon: <CloseCircleFilled className="text-rose-500" />
  }
};

export default function Banner({
  tone = 'info',
  title,
  description,
  action,
  icon
}) {
  const cfg = TONE_STYLES[tone] || TONE_STYLES.info;
  return (
    <div
      className={
        'rounded-xl border px-4 py-3 flex items-start gap-3 ' + cfg.container
      }
    >
      <span className="text-lg leading-6 mt-0.5">{icon || cfg.icon}</span>
      <div className="flex-1 min-w-0">
        {title ? (
          <p className="font-semibold m-0 leading-snug">{title}</p>
        ) : null}
        {description ? (
          <p className="text-sm opacity-90 mt-0.5 mb-0 leading-snug">
            {description}
          </p>
        ) : null}
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
  );
}
